import { lazy } from 'react';
export const lazyWithRetry = (factory, onError = () => window.location.reload()) => lazy(() => factory().catch(() => {
    onError();
    return new Promise(() => { });
}));
